import { Link } from "react-router-dom";
import { Settings2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import BuyerSidebarPreferenceToggle from "@/components/BuyerSidebarPreferenceToggle";
import BuyerModuleVisibilityPanel from "@/components/BuyerModuleVisibilityPanel";
import AppBackgroundThemePanel from "@/components/AppBackgroundThemePanel";
import OperationalDataToolsSections from "@/components/dataManagement/OperationalDataToolsSections";
import { useOperationalDataManagement } from "@/lib/useOperationalDataManagement";

/**
 * Pestaña Herramientas del Panel General — vista operativa para titular/comprador.
 * @param {{ isPlatformDesigner?: boolean, buyerPreviewActive?: boolean }} props
 */
export default function PanelHerramientasContent({ isPlatformDesigner = false, buyerPreviewActive = false }) {
  const dm = useOperationalDataManagement({ enabled: true });
  const showDesignerLink = isPlatformDesigner && !buyerPreviewActive;

  return (
    <section aria-label="Herramientas del sistema" data-testid="panel-herramientas-content" className="space-y-4">
      <div className="flex flex-wrap items-center gap-2">
        <h2 className="text-sm font-bold uppercase tracking-wider text-[#0F2D5C]">Herramientas</h2>
        <span className="text-[11px] text-slate-500">Salud, respaldo y preferencias de navegación</span>
      </div>

      <BuyerSidebarPreferenceToggle />

      {showDesignerLink ? (
        <>
          <BuyerModuleVisibilityPanel />
          <AppBackgroundThemePanel />
        </>
      ) : null}

      <OperationalDataToolsSections variant="embedded" dm={dm} showDesignerExtras={false} />

      {showDesignerLink ? (
        <div className="rounded-md border border-dashed border-slate-300 bg-slate-50/80 p-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <div>
            <p className="text-sm font-semibold text-[#0F2D5C]">Gestión técnica avanzada</p>
            <p className="text-xs text-slate-600 mt-1 max-w-xl">
              Pre-flight, detalle por módulo y mantenimiento preventivo solo para diseñador de plataforma.
            </p>
          </div>
          <Button type="button" variant="outline" size="sm" className="h-8 rounded-sm text-xs shrink-0" asChild>
            <Link to="/gestion-datos" data-testid="panel-herramientas-gestion-datos-link">
              <Settings2 className="w-3.5 h-3.5 mr-1.5" aria-hidden />
              Abrir gestión de datos
            </Link>
          </Button>
        </div>
      ) : null}
    </section>
  );
}
